import {
  useGetGeneralInfoCommonInfoQuery,
  useCollectGeneralInfosMutation,
} from "../../features/board/generalInfoApi";
import { useGeneralInfoRoutes } from "./routes";
import { Collapse, message } from "antd";
import { GeneralInfoCommonInfoModel } from "../../entities/generalInfo";
import { Spin, PageHeader, Tabs, Descriptions, Button } from "antd";
import { DateTimeViewer } from "../../components";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export { useGeneralInfoRoutes };

const GeneralInfosIndexPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabActiveKey = location.pathname.toLowerCase().includes("farabourse")
    ? "faraBourse"
    : "bourse";

  const { data, isLoading, isFetching } =
    useGetGeneralInfoCommonInfoQuery(undefined);

  const [collectData, { isLoading: isCollecting }] =
    useCollectGeneralInfosMutation();

  const collect = async (model: any) => {
    try {
      message.loading({
        content: "در حال گردآوری",
        key: "collectData",
        duration: 0,
      });

      await collectData(model).unwrap();

      message.success({
        content: "گردآوری اطلاعات با موفقیت انجام شد",
        key: "collectData",
        duration: 5,
      });

      return true;
    } catch {
      message.error({
        content: "گردآوری اطلاعات با خطا مواجه شد",
        key: "collectData",
        duration: 5,
      });

      return false;
    }
  };

  const info: GeneralInfoCommonInfoModel = {
    bourseTotalRecords: data?.bourseTotalRecords ?? 0,
    faraBourseTotalRecords: data?.faraBourseTotalRecords ?? 0,
    bourseLastPriceInformationAt: data?.bourseLastPriceInformationAt,
    faraBourseLastPriceInformationAt: data?.faraBourseLastPriceInformationAt,
  };

  const switchTab = (activeKey: string) => {
    navigate(activeKey, { state: location.state });
  };

  return (
    <div>
      <Collapse>
        <Collapse.Panel
          key={1}
          header={<span className="text-lg">اطلاعات کلی بازار</span>}
          extra={[
            <Button
              key="1"
              type="primary"
              onClick={collect}
              loading={isCollecting}
              icon={
                <FontAwesomeIcon
                  className="anticon align-middle"
                  icon={faPlusCircle}
                />
              }
            >
              کالکت
            </Button>,
          ]}
        >
          <Spin spinning={isLoading || isFetching}>
            <Tabs
              activeKey={tabActiveKey}
              tabPosition="top"
              onTabClick={switchTab}
            >
              <Tabs.TabPane tab="بورس" key="bourse">
                <Descriptions
                  size="small"
                  column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
                >
                  <Descriptions.Item
                    label="تعداد کل"
                    labelStyle={{ color: "gray" }}
                  >
                    {info.bourseTotalRecords}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label="آخرین اطلاعات"
                    labelStyle={{ color: "gray" }}
                  >
                    <DateTimeViewer
                      value={info.bourseLastPriceInformationAt}
                      mode="distance"
                    />
                  </Descriptions.Item>
                </Descriptions>
              </Tabs.TabPane>
              <Tabs.TabPane tab="فرابورس" key="faraBourse">
                <Descriptions
                  size="small"
                  column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
                >
                  <Descriptions.Item
                    label="تعداد کل"
                    labelStyle={{ color: "gray" }}
                  >
                    {info.faraBourseTotalRecords}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label="آخرین اطلاعات"
                    labelStyle={{ color: "gray" }}
                  >
                    <DateTimeViewer
                      value={info.faraBourseLastPriceInformationAt}
                      mode="distance"
                    />
                  </Descriptions.Item>
                </Descriptions>
              </Tabs.TabPane>
            </Tabs>
          </Spin>
        </Collapse.Panel>
      </Collapse>
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
};

export default GeneralInfosIndexPage;
